<template>
  <div class="page">
    <div class="mask"></div>
    <div class="popup">
      <p class="popup-text">
        Yuli does not belong to current account, you`re unable to claim the
        prize.
      </p>
      <img
        class="popup-image"
        :src="
          require('@/assets/images/YuliApp/storageActivity/img_robot@2x.png')
        "
      />
      <div class="popup-button" @click="handleClose">Confirm</div>
    </div>
  </div>
</template>
<script>
export default {
  setup(props, ctx) {
    /**
     * 处理关闭
     */
    const handleClose = () => {
      ctx.emit("close");
    };
    return {
      handleClose,
    };
  },
};
</script>

<style lang="less" scoped>
p {
  margin: 0;
  padding: 0;
}
.page {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;
  }
  .popup {
    box-sizing: border-box;
    background-image: url("~@/assets/images/YuliApp/storageActivity/error_bg.png");
    background-size: 100% 100%;
    position: absolute;
    z-index: 9999;
    width: 320px;
    // height: 264px;
    top: 25.25%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 42px 0 31px 0;
    &-text {
      width: 270px;
      color: rgba(128, 142, 182, 1);
      font-size: 14px;
      font-weight: 400;
      font-family: "PingFang HK";
      text-align: center;
      line-height: 16.8px;
    }
    &-image {
      margin-top: 32px;
      width: 130px;
      height: 140px;
    }
    &-button {
      margin-top: 38px;
      width: 110px;
      height: 44px;
      background-image: url("~@/assets/images/YuliApp/storageActivity/confirm_button.png");
      background-size: 100% 100%;

      color: rgba(218, 227, 235, 1);
      font-size: 16px;
      font-weight: 700;
      font-family: "PingFang HK";
      text-align: center;
      line-height: 44px;
    }
  }
}
</style>
